<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>


<app-main></app-main>